//frontend/src/store/authStore.js

import { create } from "zustand";

export const useAuthStore = create((set) => ({
  user: null,
  token: null,
  hydrated: false,

  setSession: (session) =>
    set({
      user: session?.user ?? null,
      token: session?.access_token ?? null,
      hydrated: true,
    }),

  clearSession: () =>
    set({
      user: null,
      token: null,
      hydrated: true,
    }),
}));